import { TimelineMax, SteppedEase } from 'gsap';

const ViolenceLoop = (list) => {
  const tl = new TimelineMax({ paudes: true, repeat: -1 });
  tl.addLabel('start');
  list.forEach((el, index) => {
    const t = new TimelineMax({ repeat: -1, delay: 0.5 * index });
    t.to(el, 2, {
      alpha: 0.2,
      ease: SteppedEase.config(4),
    });
    tl.add(t, 'start');
  });
  return tl;
};

export default ViolenceLoop;
